import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CargasFamiliaresDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CargasFamiliaresService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCargasFamiliaresService(): Observable<BodyListResponse<CargasFamiliaresDTO>> {
    return this.http.get<BodyListResponse<CargasFamiliaresDTO>>(API_URL + '/api/v1/cargasFamiliares/todos');
  }

  guardarCargasFamiliaresService(cargasFamiliaresDTO: CargasFamiliaresDTO): Observable<CargasFamiliaresDTO> {
    return this.http.post<CargasFamiliaresDTO>(API_URL + '/api/v1/cargasFamiliares', cargasFamiliaresDTO);
  }

  getCargasFamiliaresPorCodigoCargasFamiliaresService(codigoCargasFamiliares: string): Observable<BodyResponse<CargasFamiliaresDTO>> {
    return this.http.get<BodyResponse<CargasFamiliaresDTO>>(API_URL + '/api/v1/cargasFamiliares/' + codigoCargasFamiliares);
  }
}
